<template>
  <div class="app-container">
    <div class="title-row"><span class="title">开奖公告</span></div>
    <div class="content-change">
      <div class="notice-item ssq">
        <div class="winning-code">
          <div class="logo_container">
            <img src="@/assets/lottery/logo-ssq.png" alt="">
          </div>
          <div class="notice-content">
            <div class="notice-content-title">
              福彩双色球<span class="stage">第{{ ssq.period }}期</span>
              开奖日期：<span class="date">{{ ssq.lotteryDate }}</span>
              奖池滚存：
              <count-to :start-val="0" :end-val="ssq.pondAmount || 0" :duration="2600" class="red" prefix="￥" suffix="元"/>
            </div>

            <div class="qiu">
              <div class="num red-1">{{ ssq.redOne }}</div>
              <div class="num red-1">{{ ssq.redTwo }}</div>
              <div class="num red-1">{{ ssq.redThree }}</div>
              <div class="num red-1">{{ ssq.redFour }}</div>
              <div class="num red-1">{{ ssq.redFive }}</div>
              <div class="num red-1">{{ ssq.redSix }}</div>
              <div class="num blue-1">{{ ssq.blueOne }}</div>
            </div>
          </div>
        </div>
        <div class="date-history-wrap">
          <div class="date-history">
            <div class="time">每周二、 四、 日开奖</div>
            <div class="btn1" v-hasPermi="['lottery:ssq:list']">
              <el-button type="text" class="btn1-txt" @click="handleHistory('ssq')">
                <i class="el-icon-time" ></i>
                <br>
                往期
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="notice-item kl8">
        <div class="winning-code">
          <div class="logo_container">
            <img src="@/assets/lottery/logo-kl8.png" alt="">
          </div>
          <div class="notice-content" >
            <div class="notice-content-title">
              福彩快乐8<span class="stage">第{{ kl8.period }}期</span>
              开奖日期：<span class="date">{{ kl8.lotteryDate }}</span>
              "选十中十"奖池滚存：
              <count-to :start-val="0" :end-val="kl8.pondAmount || 0" :duration="3000" :decimals="2" class="red" prefix="￥" suffix="元"/>
            </div>
            <div class="qiu">
              <div class="num red-2">{{ kl8.num1 }}</div>
              <div class="num red-2">{{ kl8.num2 }}</div>
              <div class="num red-2">{{ kl8.num3 }}</div>
              <div class="num red-2">{{ kl8.num4 }}</div>
              <div class="num red-2">{{ kl8.num5 }}</div>
              <div class="num red-2">{{ kl8.num6 }}</div>
              <div class="num red-2">{{ kl8.num7 }}</div>
              <div class="num red-2">{{ kl8.num8 }}</div>
              <div class="num red-2">{{ kl8.num9 }}</div>
              <div class="num red-2">{{ kl8.num10 }}</div>
              <div class="num red-2">{{ kl8.num11 }}</div>
              <div class="num red-2">{{ kl8.num12 }}</div>
              <div class="num red-2">{{ kl8.num13 }}</div>
              <div class="num red-2">{{ kl8.num14 }}</div>
              <div class="num red-2">{{ kl8.num15 }}</div>
              <div class="num red-2">{{ kl8.num16 }}</div>
              <div class="num red-2">{{ kl8.num17 }}</div>
              <div class="num red-2">{{ kl8.num18 }}</div>
              <div class="num red-2">{{ kl8.num19 }}</div>
              <div class="num red-2">{{ kl8.num20 }}</div>
            </div>
          </div>
        </div>
        <div class="date-history-wrap">
          <div class="date-history">
            <div class="time" >每日开奖</div>
            <div class="btn1" v-hasPermi="['lottery:kl8:list']">
              <el-button type="text" class="btn1-txt" @click="handleHistory('kl8')">
                <i class="el-icon-time" ></i>
                <br>
                往期
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="notice-item fc3d">
        <div class="winning-code">
          <div class="logo_container">
            <img src="@/assets/lottery/logo-fc3d.png" alt="">
          </div>
          <div class="notice-content">
            <div class="notice-content-title">
              福彩3D<span class="stage">第{{ fc3d.period }}期</span>
              开奖日期：<span class="date">{{ fc3d.lotteryDate }}</span>
            </div>

            <div class="qiu">
              <div class="num blue-2">{{ fc3d.num1 }}</div>
              <div class="num blue-2">{{ fc3d.num2 }}</div>
              <div class="num blue-2">{{ fc3d.num3 }}</div>
            </div>
          </div>
        </div>
        <div class="date-history-wrap">
          <div class="date-history">
            <div class="time">每日开奖</div>
            <div class="btn1" v-hasPermi="['lottery:fc3d:list']">
              <el-button type="text" class="btn1-txt" @click="handleHistory('fc3d')">
                <i class="el-icon-time" ></i>
                <br>
                往期
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="notice-item qlc">
        <div class="winning-code">
          <div class="logo_container">
            <img src="@/assets/lottery/logo-qlc.png" alt="">
          </div>
          <div class="notice-content">
            <div class="notice-content-title">
              福彩七乐彩<span class="stage">第{{ qlc.period }}期</span>
              开奖日期：<span class="date">{{ qlc.lotteryDate }}</span>
              奖池滚存：
              <count-to :start-val="0" :end-val="qlc.pondAmount || 0" :duration="2500" class="red" prefix="￥" suffix="元"/>
            </div>

            <div class="qiu">
              <div class="num orange">{{ qlc.num1 }}</div>
              <div class="num orange">{{ qlc.num2 }}</div>
              <div class="num orange">{{ qlc.num3 }}</div>
              <div class="num orange">{{ qlc.num4 }}</div>
              <div class="num orange">{{ qlc.num5 }}</div>
              <div class="num orange">{{ qlc.num6 }}</div>
              <div class="num orange">{{ qlc.num7 }}</div>
              <div class="num orange-dark">{{ qlc.numSpecial }}</div>
            </div>
          </div>
        </div>
        <div class="date-history-wrap">
          <div class="date-history">
            <div class="time">每周一、 三、 五开奖</div>
            <div class="btn1" v-hasPermi="['lottery:qlc:list']">
              <el-button type="text" class="btn1-txt" @click="handleHistory('qlc')">
                <i class="el-icon-time" ></i>
                <br>
                往期
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="notice-item dlt">
        <div class="winning-code">
          <div class="logo_container">
            <img src="@/assets/lottery/logo-dlt.png" alt="">
          </div>
          <div class="notice-content">
            <div class="notice-content-title">
              体彩大乐透<span class="stage">第{{ dlt.period }}期</span>
              开奖日期：<span class="date">{{ dlt.lotteryDate }}</span>
              奖池滚存：
              <count-to :start-val="0" :end-val="dlt.pondAmount || 0" :duration="2100" class="red" prefix="￥" suffix="元"/>
            </div>
            <div class="qiu">
              <div class="num blue-3">{{ dlt.redOne }}</div>
              <div class="num blue-3">{{ dlt.redTwo }}</div>
              <div class="num blue-3">{{ dlt.redThree }}</div>
              <div class="num blue-3">{{ dlt.redFour }}</div>
              <div class="num blue-3">{{ dlt.redFive }}</div>
              <div class="num orange">{{ dlt.blueOne }}</div>
              <div class="num orange">{{ dlt.blueTwo }}</div>
            </div>
          </div>
        </div>
        <div class="date-history-wrap">
          <div class="date-history">
            <div class="time">每周一、 三、 六开奖</div>
            <div class="btn1" v-hasPermi="['lottery:dlt:list']">
              <el-button type="text" class="btn1-txt" @click="handleHistory('dlt')">
                <i class="el-icon-time" ></i>
                <br>
                往期
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="notice-item pl3">
        <div class="winning-code">
          <div class="logo_container">
            <img src="@/assets/lottery/logo-pl3.png" alt="">
          </div>
          <div class="notice-content">
            <div class="notice-content-title">
              体彩排列三<span class="stage">第{{ pl3.period }}期</span>
              开奖日期：<span class="date">{{ pl3.lotteryDate }}</span>
            </div>

            <div class="qiu">
              <div class="num purple">{{ pl3.num1 }}</div>
              <div class="num purple">{{ pl3.num2 }}</div>
              <div class="num purple">{{ pl3.num3 }}</div>
            </div>
          </div>
        </div>
        <div class="date-history-wrap">
          <div class="date-history">
            <div class="time">每日开奖</div>
            <div class="btn1" v-hasPermi="['lottery:pl3:list']">
              <el-button type="text" class="btn1-txt" @click="handleHistory('pl3')">
                <i class="el-icon-time" ></i>
                <br>
                往期
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="notice-item pl5">
        <div class="winning-code">
          <div class="logo_container">
            <img src="@/assets/lottery/logo-pl5.png" alt="">
          </div>
          <div class="notice-content">
            <div class="notice-content-title">
              体彩排列五<span class="stage">第{{ pl5.period }}期</span>
              开奖日期：<span class="date">{{ pl5.lotteryDate }}</span>
              奖池滚存：
              <count-to :start-val="0" :end-val="pl5.pondAmount || 0" :duration="2350" class="red" prefix="￥" suffix="元"/>
            </div>

            <div class="qiu">
              <div class="num purple">{{ pl5.num1 }}</div>
              <div class="num purple">{{ pl5.num2 }}</div>
              <div class="num purple">{{ pl5.num3 }}</div>
              <div class="num purple">{{ pl5.num4 }}</div>
              <div class="num purple">{{ pl5.num5 }}</div>

            </div>
          </div>
        </div>
        <div class="date-history-wrap">
          <div class="date-history">
            <div class="time">每日开奖</div>
            <div class="btn1" v-hasPermi="['lottery:pl5:list']">
              <el-button type="text" class="btn1-txt" @click="handleHistory('pl5')">
                <i class="el-icon-time" ></i>
                <br>
                往期
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="notice-item qxc">
        <div class="winning-code">
          <div class="logo_container">
            <img src="@/assets/lottery/logo-7xc.png" alt="">
          </div>
          <div class="notice-content">
            <div class="notice-content-title">
              体彩七星彩<span class="stage">第{{ qxc.period }}期</span>
              开奖日期：<span class="date">{{ qxc.lotteryDate }}</span>
              奖池滚存：
              <count-to :start-val="0" :end-val="qxc.pondAmount || 0" :duration="2500" class="red" prefix="￥" suffix="元"/>
            </div>

            <div class="qiu">
              <div class="num orange-dark">{{ qxc.redOne }}</div>
              <div class="num orange-dark">{{ qxc.redTwo }}</div>
              <div class="num orange-dark">{{ qxc.redThree }}</div>
              <div class="num orange-dark">{{ qxc.redFour }}</div>
              <div class="num orange-dark">{{ qxc.redFive }}</div>
              <div class="num orange-dark">{{ qxc.redSix }}</div>
              <div class="num blue-1">{{ qxc.blueOne }}</div>
            </div>
          </div>
        </div>
        <div class="date-history-wrap">
          <div class="date-history">
            <div class="time">每周二、 五、 日开奖</div>
            <div class="btn1" v-hasPermi="['lottery:qxc:list']">
              <el-button type="text" class="btn1-txt" @click="handleHistory('qxc')">
                <i class="el-icon-time" ></i>
                <br>
                往期
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CountTo from "vue-count-to";

import {latestSsq} from "@/api/lottery/ssq";
import {latestDlt} from "@/api/lottery/dlt";
import {latestKl8} from "@/api/lottery/kl8";
import {latestQxc} from "@/api/lottery/qxc";
import {latestQlc} from "@/api/lottery/qlc";
import {latestPl5} from "@/api/lottery/pl5";
import {latestPl3} from "@/api/lottery/pl3";
import {latestFc3d} from "@/api/lottery/fc3d";

export default {
  components: {CountTo},
  data() {
    return {
      ssq: {},
      kl8: {},
      fc3d: {},
      qlc: {},
      dlt: {},
      qxc: {},
      pl3: {},
      pl5: {}
    }
  },
  created() {
    this.getLatest()
  },
  methods: {
    getLatest() {
      latestSsq().then(res => {
        this.ssq = res.data
      })
      latestKl8().then(res => {
        this.kl8 = res.data
      })
      latestFc3d().then(res => {
        this.fc3d = res.data
      })
      latestQlc().then(res => {
        this.qlc = res.data
      })
      latestDlt().then(res => {
        this.dlt = res.data
      })
      latestPl3().then(res => {
        this.pl3 = res.data
      })
      latestPl5().then(res => {
        this.pl5 = res.data
      })
      latestQxc().then(res => {
        this.qxc = res.data
      })
    },
    handleHistory(type){
      this.$router.push({path: '/tool/lottery-'+type})
    }
  }
}
</script>
<style lang="scss" scoped>
// --- 变量定义 ---
$color-primary-red: #e81f18;
$color-bg-gray: #f8f8f8;
$color-bg-white: #fff;
$color-border: #c5c5c5;
$color-text-red: #FF0000;
$color-link: #337ab7;
$color-link-hover: #20A0FF;

// 图片路径变量 (方便统一修改)
$img-path: "../../assets/lottery";

// --- 样式代码 ---

.content-change {
  border-top: 6px solid $color-primary-red;

  // 列表项样式
  .notice-item {
    position: relative;
    overflow: hidden;
    padding: 14px 30px 14px 0;
    background: $color-bg-gray;
    border-bottom: 1px dashed $color-border;

    // 偶数行背景色
    &:nth-child(2n) {
      background: $color-bg-white;
    }

    // 中奖号码区域
    .winning-code {
      width: 82%;
      overflow: hidden;
    }

    // 左侧 Logo 容器
    .logo_container {
      position: absolute;
      width: 100px;
      top: 0;
      left: 20px;
      height: 100%;

      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100px;
        height: 100px;
      }
    }

    // 中间内容区域
    .notice-content {
      float: left;
      width: 640px;
      margin-left: 140px;

      .notice-content-title {
        padding-left: 5px;

        .stage {
          margin-left: 10px;
          font-weight: bold;
        }

        .red {
          color: $color-text-red;
          font-weight: bold;
        }
      }

      // 球号区域
      .qiu {
        margin-top: 4px;
        overflow: hidden;
        position: relative;

        .num {
          position: relative;
          width: 42px;
          height: 48px;
          display: inline-block;
          vertical-align: middle;
          margin: 5px;
          font-size: 24px;
          border-radius: 33px;
          color: #ffffff;
          text-align: center;
          line-height: 48px;
          z-index: 2;
        }
      }
    }

    // 右侧日期历史区域
    .date-history-wrap {
      display: flex;
      width: 18%;
      position: absolute;
      right: 30px;
      top: 0;
      height: 100%;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .date-history {
        width: 100%;
        height: 88px;
        text-align: right;

        .time {
          text-align: right;
        }

        .btn1 {
          margin-top: 15px;
          text-align: right;

          // 按钮文本交互
          .btn1-txt {
            color: $color-link;

            &:hover {
              color: $color-link-hover;
            }

            i {
              font-size: 22px;
              margin-bottom: 4px;
            }

            img {
              width: 20px;
              height: 20px;
            }
          }
        }
      }
    }
  }

  // --- 快乐8 (kl8) 特定样式 ---
  .kl8 {
    .notice-content {
      width: 70%;

      .qiu {
        width: 560px;
      }
    }
  }
}

// --- 球号背景色类 (使用插值语法简化) ---

// 红色系
.red-1 {
  background: url("#{$img-path}/red-1.png") no-repeat center center;
  background-size: contain;
}

.red-2 {
  background: url("#{$img-path}/red-2.png") no-repeat center center;
  background-size: contain;
}

// 蓝色系
.blue-1 {
  background: url("#{$img-path}/blue-1.png") no-repeat center center;
  background-size: contain;
}

.blue-2 {
  background: url("#{$img-path}/blue-2.png") no-repeat center center;
  background-size: contain;
}

.blue-3 {
  background: url("#{$img-path}/blue-3.png") no-repeat center center;
  background-size: contain;
}

// 其他色系
.orange {
  background: url("#{$img-path}/orange.png") no-repeat center center;
  background-size: contain;
}

.orange-dark {
  background: url("#{$img-path}/orange_dark.png") no-repeat center center;
  background-size: contain;
}

.purple {
  background: url("#{$img-path}/purple.png") no-repeat center center;
  background-size: contain;
}
</style>
